import angular from "angular";

angular
    .module('app')
    .component('reviewsControl', {
        template: require('./reviews-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            'courses': '<'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '15';

    $ctrl.search = null;
    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';
    $ctrl.student = null;
    $ctrl.user = null;
    $ctrl.course = null;
    $ctrl.ratingFilter = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/reviews/get-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    student_id: $ctrl.student ? $ctrl.student.id : null,
                    course_id : $ctrl.course ? $ctrl.course.id : null,
                    rating : $ctrl.ratingFilter,
                }
            })
            .then(
                function (response) {
                    $ctrl.total = response.data.total;
                    $ctrl.reviews = response.data.data;
                },
                function (error) {

                }
            );
    };

    $ctrl.reviewReply = function (review) {
        $uibModal
            .open({
                component: 'reviewReplyForm',
                resolve: {
                    review: function () {
                        return review;
                    }
                }
            })
            .result
            .then(
                function (res) {
                    review.reply = res.reply;
                },
                function () {
                }
            );
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.orderBy = 'id';
        $ctrl.orderDir = 'desc';
        $ctrl.course = null;
        $ctrl.student = null;
        $ctrl.ratingFilter = null;
        $ctrl.getList();
    };


    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.deleteReview = function (review,id) {

        if (!confirm('Вы действительно хотите удалть данный отзыв?')) {
            return;
        }
        $http
            .delete(`reviews/${review.id}`)
            .then(
                function (response) {
                    $ctrl.getList();
                    Notifier.success('Комментарий успешно удален', 2);
                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                }
            );
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.approved = function (review) {
        $http
            .post(`/admin/reviews/${review.id}/approved`);
    };
}
